import escapeStringRegexp from 'escape-string-regexp';

export const getSupportedGlyphsRegExp = (glyphs: string[]) =>
  new RegExp(`[\\s${escapeStringRegexp(glyphs.join(''))}]`, 'i');
